<template>
  <div>
    <!-- nav-bar start -->
    <nav-bar v-on:getLatLong="onLocationClick" :settingData="$auth.setting"></nav-bar>
    <!-- nav-bar end -->

    <!-- Resturant start -->
    <section class="resturant-main tab-content header-top">
      <div class="hm-slider-responsive" v-if="is_scrren_hide">
        <home-nav-bar v-on:getLatLong="onLocationClick"></home-nav-bar>
      </div>
      <div class="slider-home-top cust-slider-top" v-if="
        $auth && $auth.setting && restaurant_id != '' && cateMenus.length > 0
      ">
        <!-- <div class="slider-home-top cust-slider-top" > -->
        <div class="container">
          <div class="row">
            <div class="col-md-12">
              <home-slider v-if="
                showBanner &&
                $auth &&
                $auth.setting &&
                $auth.getVendorId() > 0
              " @getRestaurantData="getRestaurantByBanner" :v-on:getMobileLatLong="onLocationClick"
                :restaurant_id="restaurant_id" />
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="category-item-main" id="resturant-item-main" v-if="showBannerLoading">
              <skeleton-loader-vue v-for="count in 4" :key="count" type="string" width="100%" height="150px"
                style="border-radius: 5px" class="resturant-item busines-img-box d-flex align-items-start" />
            </div>
          </div>
        </div>
      </div>

      <div class="d-flex align-items-center viewinfo-desktop">
        <marquee v-if="
          singleRestaurant &&
          singleRestaurant.weather_text != 'null' &&
          singleRestaurant.weather_text != ''
        " class="marque-text custom-marque" attribute_name="attribute_value" attributes>{{
          singleRestaurant.weather_text }}</marquee>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <!--------Single vendor Start---------------->

            <div v-if="iscateMenusLoader" class="hme-cate-mnu-cls">
              <a href="javascript:void(0);" v-for="prod in 7" :key="prod">
                <div id="menucateID" class="menucate-cls">
                  <skeleton-loader-vue type="string" height="150px" class="menu-cat-img" width="150px"
                    style="border-radius: 4px" />
                  <h4>
                    <skeleton-loader-vue type="string" width="60%" height="20px"
                      style="margin: 5px auto; border-radius: 4px" />
                  </h4>
                </div>
              </a>
            </div>
            <div v-if="cateMenus.length > 0" class="hme-cate-mnu-cls" :class="onGoingOrdersList.length > 0 &&
              isOrderDisplay &&
              top_picks.length <= 0
              ? 'list-category-wrapper'
              : 'abcd'
              " id="test">
              <home-title title="List Category" subtitle="" :restaurantData="singleRestaurant"></home-title>
              <div class="category-item-main-theme1 cat-layout-business1">
                <a href="javascript:void(0);" v-for="catmenu in cateMenus" :key="catmenu.id"
                  @click="getSingleRestaurant(catmenu.id, Array.isArray(catmenu.items))">
                  <menu-category :menu="catmenu" :pagename="pagename"></menu-category>
                </a>
              </div>
            </div>

            <div v-if="cateMenus.length > 0 && top_picks.length > 0" class="hme-cate-mnu-cls top-pics-slide-view"
              :class="onGoingOrdersList.length > 0 && isOrderDisplay
                ? 'top-pickes-wrapper'
                : ''
                ">
              <home-title title="Top Picks" subtitle=""></home-title>
              <TopPicks :top_picks="top_picks" :restaurant_on_off="singleRestaurant.restaurant_on_off"
                :restaurant_id="restaurant_id"></TopPicks>
            </div>


            <SystemMessage v-if="
              cateMenusNotFound &&
              this.$auth.setting &&
              cateMenus.length == 0 &&
              !iscateMenusLoader
            "></SystemMessage>
          </div>
        </div>
      </div>
    </section>
    <!-- Resturant start -->

    <BusinessClosedModal />

    <!-------------Coupen Modal Start----------------------->
    <div class="modal fade order-placed" data-backdrop="static" data-keyboard="false" id="coupenModal" tabindex="-1"
      aria-labelledby="coupenModallabel" aria-hidden="true" ref="coupenModalRef" style="z-index: 9999">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content coupenmodal">
          <div class="modal-header">
            <h4 class="modal-title" id="filterLabel"></h4>
            <a data-dismiss="modal" class="lnk">{{ $t("Close") }}</a>
          </div>
          <div class="modal-body text-center">
            <img :src="promoDetails.coupon_image" />
            <h4>{{ promoDetails.coupon_name }}</h4>
            <p>{{ promoDetails.description }}</p>
          </div>
          <div class="modal-footer full-btn d-block">
            <a href="javascript:void(0);" @click="doCopy(promoDetails.coupon_code)" data-dismiss="modal">{{ $t("Copy")
              }}</a>
          </div>
        </div>
      </div>
    </div>
    <!-------------Coupen Modal End----------------------->

    <!--Alert Modal start-->
    <AlertModal v-if="isAlert" :DisplayAlertData="AlertData" v-on:modalClose="onModalCloseFun"></AlertModal>
    <!--Alert Modal End-->
    <a v-if="whatsappSupport != ''" :href="'https://api.whatsapp.com/send?phone=' + whatsappSupport" class="float"
      target="_blank">
      <img class="wp-button" src="@/assets/images/whatsapp-icon.png" />
    </a>
    <!----------Ongoing Order Start------------------>
    <div class="on-go-order cust-gorder home-page-order-slider" v-if="onGoingOrdersList.length > 0 && isOrderDisplay">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="on-going-order" v-bind="newsettings">
              <div class="oder-img" v-for="(onGoing, index) in onGoingOrdersList" :key="index">
                <p class="dsply-msg" v-if="
                  !onGoing.delayMsg &&
                  onGoing.delivery_pickup_types == 'Delivery'
                ">
                  {{ displayMSG }}
                </p>
                <router-link class="odr-bk" v-if="onGoing.type == 'order'" :to="{
                  name: 'order-status',
                  params: { order_id: base64_encode(onGoing.id) },
                }">
                  <div class="slide-content w-100">
                    <div class="slide-item-img">
                      <img :src="onGoing.icon_image" @error="imageErrorHandle"/>
                    </div>
                    <div class="slide-item-price">
                      <p class="restname">{{ onGoing.restaurant_name }}</p>
                      <div class="slide-item-status">
                        <span class="item-status" v-if="onGoing.order_status == 'OnTheWay'">On The Way</span>
                        <span class="item-status" v-else-if="onGoing.order_status == 'ReadyToServe'">Food Ready</span>
                        <span class="item-status" v-else-if="onGoing.order_status == 'InKitchen'">Preparing Your Food</span>
                        <span class="item-status" v-else-if="onGoing.order_status == 'Arrived'">Arrived</span>
                        <span class="item-status" v-else-if="onGoing.order_status == 'Placed'">Placed</span>
                        <span class="item-status" v-else-if="onGoing.order_status == 'Delivered'">Delivered</span>
                        <span class="item-status" v-else-if="onGoing.order_status == 'Cancelled'">Cancelled</span>
                        <span class="item-status" v-else-if="onGoing.order_status == 'Preparing your order'">Preparing Your Order</span>
                        
                        <p class="estmins mt-0" v-if="onGoing.estminut > 0">
                          Delivery in {{ onGoing.estminut }} Mins
                        </p>
                      </div>
                      <div class="order-id-price">
                        <span class="item-price"><span v-html="$auth.setting.currency" class="currency"></span>{{
                          parseFloat(onGoing.total_amount || 0).toFixed(2)
                          }}</span>
                        <span>Order : # {{ onGoing.id }}</span>
                      </div>
                    </div>
                  </div>
                </router-link>
                <router-link class="odr-bk" v-if="onGoing.type == 'booking'" :to="{ name: 'bookinghistory' }">
                  <div class="slide-content">
                    <div class="slide-item-img">
                      <img :src="onGoing.icon_image" />
                    </div>
                    <div class="slide-item-price">
                      <p class="restname">{{ onGoing.restaurant_name }}</p>
                      <p class="gest">
                        Number of Guests : {{ onGoing.guests_count }}
                      </p>
                      <p class="bkid">Booking id : {{ onGoing.id }}</p>
                      <p>
                        {{
                          moment(onGoing.future_delivery_date).format(
                            "DD-MM-YYYY"
                          )
                        }}
                        [{{
                          moment(onGoing.future_delivery_date).format(
                            "hh:mm a"
                          )
                        }}]
                      </p>
                    </div>
                  </div>
                  <div class="slide-item-status">
                    <span class="item-status" v-if="onGoing.order_status == 'Pending'">Pending Confirmation</span>
                    <span class="item-status" v-if="onGoing.order_status == 'Upcoming'">Confirmed</span>
                    <span class="item-status" v-if="onGoing.order_status == 'InKitchen'">Processing</span>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!----------Ongoing Order End------------------>
    <Footer></Footer>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapActions, mapGetters } from "vuex";
import HomeSlider from "@/components/HomeSlider.vue";
import HomeTitle from "@/components/HomeTitle.vue";
import NavBar from "@/components/NavBar.vue";
import HomeNavBar from "@/components/HomeNavBar.vue";
import SystemMessage from "@/components/SystemMessage.vue";
import FilterSort from "@/components/FilterSort.vue";
import AlertModal from "../components/AlertModal.vue";
import Footer from "../components/Footer.vue";
import TopPicks from "../components/TopPicks.vue";
import moment from "moment";
import MenuCategory from "@/components/MenuCategory.vue";
import BusinessClosedModal from "@/components/BusinessClosedModal.vue";
import VueSkeletonLoader from "skeleton-loader-vue";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import { imageErrorHandle } from "../helper/helper";

export default {
  name: "Home",
  components: {
    HomeSlider,
    HomeTitle,
    NavBar,
    FilterSort,
    AlertModal,
    Footer,
    MenuCategory,
    "skeleton-loader-vue": VueSkeletonLoader,
    VueSlickCarousel,
    TopPicks,
    HomeNavBar,
    SystemMessage,
    BusinessClosedModal,
  },
  data() {
    return {
      imageErrorHandle:imageErrorHandle,
      pagename: "home",
      loading: true,
      setting: {},
      addres: "",
      latitude: "",
      filter: {
        lat: "",
        lng: "",
        city: "",
        state: "",
        is_pickup_delivery: 1,
      },
      skip: 0,
      // isStopCallingApi: false,
      moment: moment,
      is_scrren_hide: window.screen.width < 1280 ? true : false,
      showBanner: false,
      whatsappSupport: "",
      isAlert: false,
      cateMenus: [],
      iscateMenusLoader: true,
      isItemLoader: true,
      isnoVendorFound: false,
      isScrollStart: false,
      singleRestaurant: {},
      cateMenusNotFound: true,
      promoDetails: {},
      isSelectCoupon: "",
      onGoingOrdersList: [],
      restaurant_id: "",
      top_picks: [],
      isOrderDisplay: true,
      showBannerLoading: true,
      settings: {
        dots: false,
        arrows: true,
        infinite: true,
        speed: 500,
        slidesToShow: 8,
        slidesToScroll: 8,
        initialSlide: 0,
        centerMode: false,
        centerPadding: "40px",
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 8,
              slidesToScroll: 8,
              infinite: true,
              dots: true,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 4,
              initialSlide: 4,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      },
      newsettings: {
        dots: false,
        arrows: false,
        infinite: false,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 3,
        initialSlide: 0,
        centerMode: false,
        centerPadding: "40px",
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              infinite: true,
              dots: true,
            },
          },
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              infinite: true,
              dots: true,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            },
          },
          {
            breakpoint: 650,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              initialSlide: 1,
            },
          },
        ],
      },
      displayMSG: "",
      // is_scrren_hide_mobile:(window.screen.width < 1024 ? true:false)
    };
  },
  // watch:{
  //   'filter.lat':function(){
  //     if(this.is_scrren_hide_mobile && this.filter.lat != ''){
  //       this.getRestaurant();
  //     }
  //   },
  // },

  computed: {
    ...mapGetters("order", ["isPickupDelivery"]),
  },

  mounted() {
    setTimeout(() => {
      if (this.$route.name == "Home") {
        this.$store.commit("order/pickupdelivery", "1");
      }
      if (
        this.$route.name == "Home" &&
        this.$auth.setting &&
        this.filter.lat != ""
      ) {
        // window.addEventListener("scroll", () => {
        //   if (
        //     window.innerHeight + window.scrollY >=
        //     document.body.offsetHeight
        //   ) {
        this.isScrollStart = true;
        // if (!this.isStopCallingApi) {
        this.getRestaurant();
        // }
        // }
        if (window.pageYOffset > 0) {
          this.isOrderDisplay = false;
        } else {
          this.isOrderDisplay = true;
        }
        // });
      }

      this.filter.lat = parseFloat(localStorage.getItem("latitude"));
      this.filter.lng = parseFloat(localStorage.getItem("longitude"));
      this.displayMSG = this.$auth?.setting?.delay_message ?? "";
      if (this.$auth.user) {
        this.OnGoingOrders();
      }
    }, 1500);
  },

  methods: {
    ...mapActions("restaurant", ["getNearestRestaurantData"]),
    ...mapActions("order", ["getOrderListWithBook"]),

    coupenModalPopup(value) {
      this.promoDetails = value;
      window.$(this.$refs.coupenModalRef).modal();
    },

    doCopy(el) {
      this.isSelectCoupon = el;
      this.$copyText(el).then(function (e) {
        navigator.clipboard.writeText(e.text);
      });
      this.$toasted.success(this.$t("Promocode Copied to clipboard."), {
        duration: 2000,
      });
    },
    /*************
     * Close Alert Modal component
     *
     *************/
    onModalCloseFun(value) {
      this.isAlert = false;
    },
    /*************
     *
     * Select location to get address and latitude and longitude to call function
     *
     *************/
    onLocationClick(value) {
      this.cateMenus = [];
      this.isItemLoader = true;
      if (value.lat && value.lng) {
        this.filter.lat = parseFloat(value.lat);
        this.filter.lng = parseFloat(value.lng);
      } else {
        this.filter.lat = parseFloat(localStorage.getItem("latitude"));
        this.filter.lng = parseFloat(localStorage.getItem("longitude"));
      }
      this.filter.city = value.city;
      this.filter.state = value.state;
      this.skip = 0;
      // this.isStopCallingApi = false;

      // this.getRestaurant();
      setTimeout(() => {
        if (value.onclick == "yes") {
          this.getRestaurant();
        }
      }, 2000);
      this.showBanner = true;
    },

    /*************
     *
     * First home slider banner call in function emit
     *
     *************/
    getRestaurantByBanner(value) {
      this.showBannerLoading = false
      this.getRestaurant();
    },

    /*************
     *
     * Multivendor for restaurnat and business category list
     * Single Restaurnat for menu category Display
     *
     *************/
    getRestaurant() {
      if (this.$auth.setting && this.filter.lat != "") {
        this.isItemLoader = false;
        this.iscateMenusLoader = true;
        this.getSingleRestaurantData();
      }
    },

    getSingleRestaurantData() {
      this.getNearestRestaurantData({
        vendor_id: this.$auth.getVendorId(),
        is_langauge: this.$store.state.lang.locale,
        latitude: this.filter.lat,
        longitude: this.filter.lng,
        delivery_type_time_slots: this.isPickupDelivery,
      }).then((data) => {
        if (data.code == 200) {
          this.cateMenus = data.Result.parent_categories;
          this.iscateMenusLoader = false;
          this.singleRestaurant = data.Result;
          this.restaurant_id = data?.Result?.restaurant_id ?? "";
          this.$auth.setRestauranID(this.restaurant_id);
          this.top_picks = data?.Result?.top_picks ?? [];
          // if(data.Result.menu_category_count > 0){
          this.showBanner = true;
          // }
          this.cateMenusNotFound = this.cateMenus.length <= 0;
          localStorage.setItem("geolocation", "");
        } else if (data.code == 101) {
          this.cateMenus = [];
          this.cateMenusNotFound = true;
          this.iscateMenusLoader = false;
          this.isnoVendorFound = true;
          this.singleRestaurant = data.Result;
          localStorage.setItem("geolocation", "");
        } else {
          this.cateMenus = [];
          this.iscateMenusLoader = false;
          this.isnoVendorFound = true;
        }
      });
    },

    /*************
     *
     * single vendor menu category Onclick to redirect Single Restautant
     *
     *************/
    getSingleRestaurant(id, isOffer = false) {
      // offer categories (coupon with items) use coupon id, not menu category id
      if (isOffer) {
        localStorage.setItem("menuCatOfferID", id);
      } else {
        localStorage.setItem("menuCatID", id);
      }
      this.$router.push({
        name: "restaurant-details",
        params: { restaurantId: btoa(this.restaurant_id) },
      });
      // this.$router.push({
      //   name: "vendor",
      //   params: {
      //     delivery_type:
      //       this.isPickupDelivery == "1"
      //         ? "delivery"
      //         : this.isPickupDelivery == "0"
      //         ? "takeaway"
      //         : this.isPickupDelivery == "2"
      //         ? "reservation"
      //         : "",
      //     restaurant_name: this.singleRestaurant.slug,
      //   },
      // });
    },
    /**
     *
     * Order with booking order function
     */
    OnGoingOrders() {
      this.getOrderListWithBook({
        vendor_id: this.$auth.getVendorId(),
        is_langauge: this.$store.state.lang.locale,
        user_id: this.$auth.user.user_id,
      }).then((data) => {
        if (data.code == 200) {
          this.onGoingOrdersList = [];
          let rsults = data.Result.reverse();
          let newOrdes = [];
          rsults.forEach((rsult) => {
            let crrntday = moment().format("YYYY-MM-DD HH:mm:ss");
            if (rsult.eta_delivery_times > 0) {
              const minutes = moment
                .utc(rsult.eta_delivery_times * 1000)
                .format("m");
              rsult.estminut = minutes;
            } else {
              const minutes = moment
                .utc(rsult.delivery_times * 1000)
                .format("m");
              rsult.estminut = minutes;
            }
            if (moment(rsult.eta).diff(crrntday, "minutes") > 0) {
              rsult.delayMsg = true;
            } else {
              rsult.delayMsg = false;
            }
            newOrdes.push(rsult);
          });
          this.onGoingOrdersList = newOrdes;
        } else {
          this.onGoingOrdersList = [];
        }
      });
    },
  },
};
</script>
